export default "__VITE_ASSET__CWa_KiqV__"